module.exports = __webpack_public_path__ + "img/T-test.84cd16cd.png";